import React, {useEffect, useState} from "react";
import UploadRow from "../uploadRow";
import {
    useGetFriendDuel,usePostFriendDuelAudio,
    usePostFriendDuelAvatar, usePostFriendDuelBackground, usePostFriendDuelForeground
} from "../../../../../_metronic/api/hooks";
import {Avatar} from "../../../../../_metronic/models";
import Loading from "../../../../../_metronic/layout/components/loading/Loading";
import {toast} from "react-toastify";

const FriendDuel = () => {
    const {data, isLoading} = useGetFriendDuel()
    const [selectedAvatar, setSelectedAvatar] = useState<Avatar>()
    const {mutate:mutateAvatarAudio} = usePostFriendDuelAudio()
    const {mutate:mutateAvatarBackground} = usePostFriendDuelBackground()
    const {mutate:mutateAvatarForeground} = usePostFriendDuelForeground()
    const {mutate:mutateChangeAvatar} = usePostFriendDuelAvatar()

    const handleChangeAvatarAudio = (file:File) => {
        const formData = new FormData();
        formData.append('file', file);
        mutateAvatarAudio(formData, {
            onSuccess: () => {
                toast.success("Register-Audio-Animation successfully uploaded");
            },
            onError: () => {
                toast.error("file was not successfully uploaded, try again")
            }
        })
    }
    const handleChangeAvatarBackground = (file:File) => {
        const formData = new FormData();
        formData.append('file', file);
        mutateAvatarBackground(formData, {
            onSuccess: () => {
                toast.success("Register-Background-Animation successfully uploaded");
            },
            onError: () => {
                toast.error("file was not successfully uploaded, try again")
            }
        })
    }
    const handleChangeAvatarForeground = (file:File) => {
        const formData = new FormData();
        formData.append('file', file);
        mutateAvatarForeground(formData, {
            onSuccess: () => {
                toast.success("Register-Foreground-Animation successfully uploaded");
            },
            onError: () => {
                toast.error("file was not successfully uploaded, try again")
            }
        })
    }
    const handleChangeAvatar = (file:File) => {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('avatar_id',` ${selectedAvatar?.id}`);
        mutateChangeAvatar(formData, {
            onSuccess: () => {
                toast.success("Avatar-Animation successfully uploaded");
            },
            onError: () => {
                toast.error("file was not successfully uploaded, try again")
            }
        })
    }
    useEffect(() => {
        if(data && data?.avatars_report.length > 0) setSelectedAvatar(data?.avatars_report[0])
    }, [data]);
    return <div className="w-100 d-flex flex-column">
        <h3 className="mb-5">Global Files</h3>
        <UploadRow title="Register-Audio-Animation" accept="audio/*" onUpload={handleChangeAvatarAudio} isExists={data?.audio.exists}/>
        <UploadRow title="Register-Background-Animation" accept=".json" onUpload={handleChangeAvatarBackground} className="mt-5" isExists={data?.background.exists}/>
        <UploadRow title="Register-Foreground-Animation" accept=".json" onUpload={handleChangeAvatarForeground} className="mt-5" isExists={data?.foreground.exists}/>

        <h3 className="mt-10">Select Avatar</h3>
        <div className="d-flex flex-wrap gap-5 py-5">
            {isLoading && <Loading/>}
            {data && data?.avatars_report.map( a =>
                <div key={a.title}
                     onClick={()=> setSelectedAvatar(a)}
                     className={`d-flex align-items-center justify-content-center rounded-circle border border-2 border-primary w-90px h-90px cursor-pointer ${selectedAvatar?.id === a.id && "border-success"}`}><p className="mb-0" style={{fontSize: '12px', textAlign:'center'}}>{a.title}</p></div>)}
        </div>

        <UploadRow title="Avatar-Animation" accept=".json" onUpload={handleChangeAvatar} className="mt-5" isExists={selectedAvatar?.has_animation}/>

    </div>
}

export default FriendDuel